/* theme.js - Melauno Aesthetics Shopify Theme */

document.addEventListener('DOMContentLoaded', function () {

  // =====================
  // NAVBAR SCROLL
  // =====================
  const navbar = document.querySelector('.navbar');

  function updateNavbar() {
    const scrolled = window.scrollY > 40;
    navbar.classList.toggle('scrolled', scrolled);
    navbar.classList.toggle('navbar--dark', scrolled);

    const whiteLogo = document.querySelector('.white-logo');
    const darkLogo = document.querySelector('.dark-logo');
    if (whiteLogo && darkLogo) {
      whiteLogo.style.display = scrolled ? 'none' : 'block';
      darkLogo.style.display = scrolled ? 'block' : 'none';
    }
  }

  updateNavbar();
  window.addEventListener('scroll', updateNavbar);

  // =====================
  // MOBILE MENU
  // =====================
  const hamburger = document.querySelector('.navbar__hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      const isOpen = mobileMenu.classList.contains('open');
      mobileMenu.classList.toggle('open');
      hamburger.querySelector('.icon-open').style.display = isOpen ? 'block' : 'none';
      hamburger.querySelector('.icon-close').style.display = isOpen ? 'none' : 'block';
    });
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('open');
        hamburger.querySelector('.icon-open').style.display = 'block';
        hamburger.querySelector('.icon-close').style.display = 'none';
      });
    });
  }

  // =====================
  // SCROLL ANIMATIONS
  // =====================
  const animatedEls = document.querySelectorAll('.fade-up, .fade-left, .fade-right');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    animatedEls.forEach(function (el) { observer.observe(el); });
  } else {
    animatedEls.forEach(function (el) { el.classList.add('visible'); });
  }

  // =====================
  // TESTIMONIALS CAROUSEL
  // =====================
  const slides = document.querySelectorAll('.testimonials__slide');
  const dots = document.querySelectorAll('.testimonials__dot');
  let current = 0;

  function goTo(index) {
    slides[current].classList.remove('active');
    dots[current].classList.remove('active');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('active');
    dots[current].classList.add('active');
  }

  const prevBtn = document.querySelector('.testimonials__nav-btn--prev');
  const nextBtn = document.querySelector('.testimonials__nav-btn--next');

  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { goTo(i); });
  });

  if (slides.length > 0) {
    setInterval(function () { goTo(current + 1); }, 6000);
  }

});


/**
 * Agrega un producto al carrito desde secciones personalizadas (ej: Sesami).
 * Imita el flujo de product-form.js: incluye el sectionId del cart en el fetch
 * para que Shopify devuelva el HTML pre-renderizado, y así CartItemsComponent
 * solo actualiza el drawer con morphSection (sin re-renderizar el header ni
 * romper el scroll).
 *
 * @param {number|string} variantId - El variant ID del producto a agregar.
 * @param {number} [quantity=1] - Cantidad a agregar.
 * @param {Object} [properties] - Propiedades de línea opcionales (line_item_properties).
 * @returns {Promise<Object|null>} El objeto del carrito actualizado, o null si hubo error.
 */
async function addToCart(variantId, quantity = 1, properties = {}) {
  // 1. Recopilar todos los sectionIds de los cart-items-component presentes en la página.
  //    Esto es lo que hace product-form.js para que Shopify devuelva el HTML
  //    pre-renderizado de cada instancia del carrito (drawer, página, etc.).
  const cartItemsComponents = document.querySelectorAll('cart-items-component');
  const sectionIds = [];
  cartItemsComponents.forEach((el) => {
    if (el instanceof HTMLElement && el.dataset.sectionId) {
      sectionIds.push(el.dataset.sectionId);
    }
  });

  const body = {
    id: Number(variantId),
    quantity: Number(quantity),
    sections: sectionIds.join(','),
    sections_url: window.location.pathname,
  };

  if (properties && Object.keys(properties).length > 0) {
    body.properties = properties;
  }

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(body),
    });

    const cartData = await response.json();

    if (cartData.status) {
      console.error('[addToCart] Error de Shopify:', cartData.message, cartData.errors);
      return null;
    }

    const cartResponse = await fetch('/cart.js');
    const fullCart = await cartResponse.json();



    const cartAddEvent = new CustomEvent('cart:update', {
      bubbles: true,
      composed: true,
      detail: {
        resource: fullCart,
        sourceId: 'custom-add-to-cart',
        data: {
          source: 'custom-add-to-cart',
          variantId: variantId.toString(),
          itemCount: fullCart.item_count,
          sections: cartData.sections, // HTML pre-renderizado por Shopify
        },
      },
    });

    document.dispatchEvent(cartAddEvent);

    toggleCartDrawer(true);
    closeModalServices();

    return fullCart;

  } catch (error) {
    console.error('[addToCart] Error inesperado:', error);
    return null;
  }
}

/**
 * Abre o cierra el drawer del carrito.
 * @param {boolean} [forceOpen] - Opcional. Si se pasa true/false, fuerza ese estado.
 */
window.toggleCartDrawer = function (forceOpen) {
  const cartDrawer = document.querySelector('cart-drawer-component');
  if (!cartDrawer) return;

  const dialog = cartDrawer.querySelector('dialog');
  const isOpen = dialog && dialog.hasAttribute('open');

  if (typeof forceOpen === 'boolean') {
    if (forceOpen && !isOpen && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else if (!forceOpen && isOpen && typeof cartDrawer.close === 'function') {
      cartDrawer.close();
    }
  } else {
    if (isOpen && typeof cartDrawer.close === 'function') {
      cartDrawer.close();
    } else if (!isOpen && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  }
};